import React, { Component } from 'react';
import $ from 'jquery';

export default class Stat extends Component {
  constructor(props)
  {
    super(props);
    this.loginKey = sessionStorage.getItem('loginKey');
    if( !this.loginKey || this.loginKey == "") {
        window.location.href = '/';
    }
    this.state = {
      data: null
    };
    this.logoPath = sessionStorage.getItem('logo');
  }
  componentDidMount()
  {
    this.requestStat();
  }
  requestStat()
  {
    const self = this;
    $.post('https://api.tfamily.co.kr/api/mobile/statistics',{
      uk: this.loginKey
    },function(data){
      let pData = JSON.parse(data);
      self.setState({
        data: pData.data
      });
      console.log(pData.data);
    });
  }
  render()
  {
    const self = this;

    return (
      <div className="centralize-wrapper">
        <div className="centralize-inner">
          <div className="centralize-content">
            <div>
              <img src={'https://api.tfamily.co.kr/' + self.logoPath} className="text-right logoMax"/>
              <br/><br/>
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>내용</th>
                  <th>설명</th>
                </tr>
              </thead>
              <tbody>
                { (self.state.data  ) ?
                  <tr>
                    <td>오늘 가입자수</td>
                    <td>{self.state.data.day_member}명</td>
                  </tr> : null
                 }
                 { (self.state.data  ) ?
                   <tr>
                     <td>오늘 이번달 가입자수</td>
                     <td>{self.state.data.month_member}명</td>
                   </tr> : null
                  }
                  { (self.state.data  ) ?
                    <tr>
                      <td>오늘 신청자수</td>
                      <td>{self.state.data.day_appl}명</td>
                    </tr> : null
                   }
                   { (self.state.data  ) ?
                     <tr>
                       <td>이번달 신청자 수</td>
                       <td>{self.state.data.month_appl}명</td>
                     </tr> : null
                    }
              </tbody>
            </table>
            <div>
              <div className="row">
              <div className="text-right">
              <a href="/Option" className="btn btn-default">구매 페이지로 돌아가기</a>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
